<template>
    <div>
        <Head><title>Users</title></Head>
        <h1 class="mb-8 text-3xl font-bold">Users</h1>
        <div class="flex items-center justify-between mb-6">
            <search-filter :show-input="true" v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <label class="block text-gray-700">Role:</label>
                <select v-model="form.role" class="form-select mt-1 w-full">
                    <option v-for="role in roles" :key="role.name" :value="role.name">
                        {{ role.name }}
                    </option>
                </select>
                <template #dateFilter>
                    <date-picker v-model="form.date" :range="true" :time-picker="false"
                                 :enable-time-picker="false" input-class-name="dp-custom-input" :multi-calendars="2"
                                 :preset-ranges="presetRanges" auto-apply>
                    </date-picker>
                </template>
            </search-filter>

        </div>

        <div class="container items-center px-4 py-8 m-auto mt-5">
            <div class="flex flex-wrap pb-3 mx-4 md:mx-24 lg:mx-0">


                <summary-card title="Total Users" :totals=usersCount #cardIcon :card-link="cardOneLink">
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="Project Owners" :totals=projectOwners #cardIcon :card-link="cardTwoLink">
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="Project Invitees" :totals=invitee #cardIcon :card-link="cardOThreeLink">
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>


                <summary-card title="InActive Users" :totals=inActive #cardIcon :card-link="cardFourLink">
                    <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

            </div>
        </div>

        <Link class="btn-indigo mb-3" href="/users/create">
            <span>Create</span>
            <span class="hidden md:inline">&nbsp;User</span>
        </Link>
    </div>
    <Table :resource="users">
        <template #cell(actions)="{ item: user }">
            <a :href="`/users/details/${user.id}`"
               class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
                Details
            </a>
        </template>

    </Table>

</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from "@/Shared/Pagination.vue";
import {Table} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {ref} from "vue";
import {
    endOfMonth,
    endOfYear,
    endOfYesterday,
    startOfMonth,
    startOfYear,
    startOfYesterday,
    subDays,
    subMonths, subYears
} from "date-fns";
import SummaryCard from "@/Shared/SummaryCard.vue";

export default {
    components: {
        SummaryCard,
        Pagination,
        Head,
        Icon,
        Link,
        SearchFilter,
        Table
    },
    layout: Layout,
    props: {
        filters: Object,
        users: Array,
        roles: Array,
        usersCount: Number,
        projectOwners: Number,
        invitee: Number,
        inActive: Number,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                role: this.filters.role,
                date: this.filters.date,
            },
            cardOneLink: "/users",
            cardTwoLink: "/users?role=projectOwers",
            cardOThreeLink: "/users?role=invitees",
            cardFourLink: "/users?role=inActive",
            presetRanges: ref([
                {label: 'Today', range: [new Date(), new Date()]},
                {label: 'Yesterday', range: [startOfYesterday(), endOfYesterday()]},
                {label: 'Last 3 Days', range: [subDays(new Date(), 2), new Date()]},
                {label: 'Last 7 Days', range: [subDays(new Date(), 6), new Date()]},
                {label: 'This month', range: [startOfMonth(new Date()), new Date()]},
                {
                    label: 'Last month',
                    range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
                },
                {
                    label: 'Last 3 months',
                    range: [startOfMonth(subMonths(new Date(), 3)), new Date()],
                },
                {
                    label: 'Last 6 months',
                    range: [startOfMonth(subMonths(new Date(), 6)), new Date()],
                },
                {label: 'This year', range: [startOfYear(new Date()), new Date()]},
                {
                    label: 'Last year',
                    range: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))]
                },
                {
                    label: 'All Times',
                    range: [startOfYear(subYears(new Date(), 1)), new Date()]
                },
            ]),
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/users', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
